import { PropsWithChildren } from 'react';

import useValidateRole, { Roles } from './useValidateRole';

interface ValidateRoleProps {
  fallback?: React.ReactNode
  requiredRole: Roles
}

function EnsureRole(props: PropsWithChildren<ValidateRoleProps>) {
  const { children, fallback, requiredRole } = props;

  const validateRole = useValidateRole();

  if (validateRole(requiredRole)) return children;
  return fallback || null;
}

export default EnsureRole;
